import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// ScrollTrigger registratie gebeurt al in @/js/lib/scroll.js; herhaling is
// idempotent maar veilig wanneer dit bestand los wordt geïmporteerd.
gsap.registerPlugin( ScrollTrigger );

// Swap de actieve color-set bg, bg-accent + foregrounds op <body> wanneer een
// sectie het midden van het viewport raakt. Geen `scrub` — CSS-transition op
// body+ [data-main] doet de crossfade. Elke triggerende sectie heeft
// `data-color-set="<key>"`. Componenten die meekleuren met de actieve sectie
// (zoals het hoofdmenu) consumeren --current-fg* / --current-bg-accent op body.
//
// Pagina's met een vaste kleur (body[data-page-color], zie hellema_page_color):
// een witte sectie houdt de kleur van de pagina in menu en accenten, alleen de
// achtergrond wordt wit.
const applySet = ( body, set ) => {
	const fgSet = ( 'default' === set || 'white' === set ) && body.dataset.pageColor ? body.dataset.pageColor : set;

	body.style.setProperty( '--current-bg', `var(--set-${ set }-bg)` );
	body.style.setProperty( '--current-fg', `var(--set-${ fgSet }-fg)` );
	body.style.setProperty( '--current-bg-accent', `var(--set-${ fgSet }-bg-accent)` );
	body.style.setProperty( '--current-fg-soft', `var(--set-${ fgSet }-fg-soft)` );
	body.style.setProperty( '--current-fg-hover-bg', `var(--set-${ fgSet }-fg-hover-bg)` );
	body.style.setProperty( '--current-fg-strong', `var(--set-${ fgSet }-fg-strong)` );
};

const initColorSets = () => {
	const body = document.body;

	// Single vacature: de pagina hoort altijd één kleur te houden — die van de
	// categorie. De gestapelde blokken dragen wisselende data-color-sets (hero
	// = categoriekleur, aandeel/waarom = white, collegas = default, cta =
	// blauw); zonder lock zou het menu per sectie verspringen. Lees de
	// categoriekleur van de article-wrapper, zet die één keer vast en sla de
	// scroll-triggers over.
	const lock = document.querySelector( '[data-vacature-color]' );
	if ( lock && lock.dataset.vacatureColor ) {
		applySet( body, lock.dataset.vacatureColor );
		return;
	}

	const sections = document.querySelectorAll( '[data-color-set]' );
	if ( ! sections.length ) {
		return;
	}

	const triggers = [];

	// Pas bij load meteen de sectie toe die het viewport-midden raakt, zodat
	// de body al op zijn plaats staat vóór er gescrold wordt (anders zit je
	// een frame op de SCSS-default). Raakt geen enkele sectie het midden,
	// dan de default-set — het menu is standaard blauw.
	const center = window.innerHeight / 2;
	const initial = Array.from( sections ).find( ( section ) => {
		if ( ! section.dataset.colorSet ) {
			return false;
		}
		const rect = section.getBoundingClientRect();
		return rect.top <= center && rect.bottom >= center;
	} );

	applySet( body, initial ? initial.dataset.colorSet : 'default' );

	sections.forEach( ( section ) => {
		const set = section.dataset.colorSet;
		if ( ! set ) {
			return;
		}

		triggers.push( ScrollTrigger.create( {
			trigger: section,
			start: 'top center',
			end: 'bottom center',
			onToggle: ( self ) => {
				if ( self.isActive ) {
					applySet( body, set );
					return;
				}

				// Geen enkele gekleurde sectie meer aan het viewport-midden
				// (boven de eerste, onder de laatste, of in een neutraal gat)
				// — terug naar de default-set: menu standaard blauw.
				if ( ! triggers.some( ( trigger ) => trigger.isActive ) ) {
					applySet( body, 'default' );
				}
			},
		} ) );
	} );
};

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initColorSets );
} else {
	initColorSets();
}

export { initColorSets };
